module.exports = __webpack_public_path__ + "static/media/hungary.ac005614.svg";